document.addEventListener("DOMContentLoaded", function() {
    // Initialize Lozad for background images in the slider
    if (typeof lozad !== 'undefined') {
      var backgroundObserver = lozad('.slide-wrapper-image.lozad', {
        load: function(el) {
          var bgImage = el.getAttribute('data-background-image');
          if (bgImage) {
            // Set background image for mobile viewport
            el.style.backgroundImage = "url('" + bgImage + "')";
            el.style.width = "100vw";
            el.style.height = "490px";
            // Mark as loaded
            el.classList.add('lozad-loaded');
          }
        }
      });
      backgroundObserver.observe();
    }

    // Countdown timer functionality
    document.querySelectorAll('.countdown[data-countdown]').forEach(function(el) {
      var countDownDate = new Date(el.getAttribute('data-countdown')).getTime();
  
      function updateCountdown() {
        var now = new Date().getTime();
        var distance = countDownDate - now;
  
        if (distance < 0) {
          el.innerHTML = "EXPIRED";
          clearInterval(timer);
          return;
        }
  
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
        el.innerHTML = days + "d : " + hours + "h : " + minutes + "m : " + seconds + "s";
      }
  
      updateCountdown();
      var timer = setInterval(updateCountdown, 1000);
    });
  });